import http from "@/http";

class AddDataToFileService {
    http

    constructor(http) {
        this.http = http
    }

    processFile(params) {
        return this.http.execute('/add-fields-to-file', params)
    }

    getTasks() {
        return this.http.get('/add-fields-to-file/tasks')
    }
}

export default new AddDataToFileService(http)